// app/store.js
import { configureStore } from "@reduxjs/toolkit";
import classReducer from "./classSlice";
import cacheReducer from "./cacheSlice";
import cartReducer from './cartSlice';

export const store = configureStore({
  reducer: {
    class: classReducer,
    cache: cacheReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload'],

        ignoredPaths: ['cache.data', 'cache.timestamps']
      }
    })
});

